"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureToggleProduction = exports.featureToggleDevelopment = void 0;
var featureToggleDevelopment = {
  core: {
    authorizationKey: 'u8gt16ks3c8jo6lhin0qfuvmh87bb6004129',
    labelsEnabled: true
  },
  scheduler: {
    featuresRefreshRate: 30,
    segmentsRefreshRate: 60,
    metricsRefreshRate: 60,
    impressionsRefreshRate: 60,
    eventsPushRate: 60,
    eventsQueueSize: 500
  },
  startup: {
    requestTimeoutBeforeReady: 20,
    retriesOnFailureBeforeReady: 3,
    readyTimeout: 20
  }
};
exports.featureToggleDevelopment = featureToggleDevelopment;
var featureToggleProduction = {
  core: {
    authorizationKey: 'hhq5f6gnsj75jqe12ov0k0r536o1ucg2f3b0',
    labelsEnabled: true
  },
  scheduler: {
    featuresRefreshRate: 180,
    segmentsRefreshRate: 360,
    metricsRefreshRate: 600,
    impressionsRefreshRate: 360,
    eventsPushRate: 360,
    eventsQueueSize: 500
  },
  startup: {
    requestTimeoutBeforeReady: 20,
    retriesOnFailureBeforeReady: 3,
    readyTimeout: 20
  },
  debug: false
};
exports.featureToggleProduction = featureToggleProduction;